/* eslint tailwindcss/no-custom-classname: off */
interface Props {
  className?: string
}
export const New: React.FC<Props> = ({ className }) => {
  return <span className={`${className || ''} new`}>NEW</span>
}
